import TablePaginate from 'components/Paginate';
import DOMPurify from 'dompurify';
import useTopicComments from 'hooks/API/GET/useTopicComments';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import useQueryParams from 'hooks/useQueryParams';
import { memo, useState } from 'react';
import { useParams } from 'react-router-dom';
import CommentDropBox, { PrintText } from './CommentDropBox';
import Icons from 'assets/Icons';
import { AppButton } from 'components';
import { contentStatus } from 'utilities/constants';

function CommentHistory() {
  const { classID, courseID, chapterID, topicID } = useParams();
  const query = useQueryParams();
  const subtopicID = query.get('subtopic');
  const lessonType = query.get('lessonType');

  const [params, setParams] = usePaginateDefaults();

  const __default = { classID, courseID, chapterID, topicID };

  const { isLoading, data, isError } = useTopicComments({
    ...__default,
    enabled: true,
    configs: { params: { ...params, subtopicID, lessonType } },
  });

  const { meta: { page, total, metaContentInfo } = {}, result = [] } = data?.data ?? {};

  const _initialState = {
    open: false,
    modal_id: null,
    dataBlockId: null,
    selectedCommentText: '',
  };
  const [openCommentModal, setOpenCommentModal] = useState({
    open: false,
    data: null,
    apiHash: null,
  });

  return (
    <>
      {openCommentModal.open && (
        <CommentDropBox
          open={openCommentModal.open}
          close={() => {
            setOpenCommentModal({ open: false, data: null, apiHash: null });
          }}
          data={{
            readyOnlyCommentsMode: true,
            apiHash: openCommentModal?.apiHash,
            openCommentModal,
            apiBodyProps: {
              lessonType,
            },
          }}
          updateBlock={() => {}}
        />
      )}
      <div class="table-responsive app-l-tab-sub">
        {isLoading ? (
          'Loading...'
        ) : isError ? (
          'Failed to load data'
        ) : (
          <>
            {result.length > 0 ? (
              <>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Comments</th>
                      {/* <th scope="col">Has responded</th> */}
                      <th scope="col">Respondent</th>
                      <th scope="col">Status</th>
                      <th scope="col">Resolver</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.map((r, i) => {
                      return (
                        <tr key={r._id}>
                          <td>
                            {r.commentText ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(r.commentText),
                                }}
                              ></span>
                            ) : r?.selectedBlock && Object.keys(r.selectedBlock).length > 0 ? (
                              <PrintText block={r.selectedBlock} hideCaption />
                            ) : (
                              '-'
                            )}
                            {}
                          </td>
                          {/* <td>
                            {r.respondentResolve ? (
                              <div className="icon">
                                <Icons.Resolved />
                              </div>
                            ) : (
                              <div className="icon">
                                <Icons.Unresolved />
                              </div>
                            )}
                          </td> */}
                          <td>{r?.assignedTo?.name ?? '-'}</td>
                          <td>
                            {r.resolved ? (
                              <div className="icon">
                                <Icons.Resolved />
                              </div>
                            ) : (
                              <div className="icon">
                                <Icons.Unresolved />
                              </div>
                            )}
                          </td>
                          <td>{r?.askedBy?.name ?? '-'}</td>
                          <td>
                            <AppButton
                              disabled={false}
                              variantClass="btn-plane b--tint m-l-btn my-4"
                              onClick={() =>
                                setOpenCommentModal({ open: true, data: r, apiHash: r._id })
                              }
                            >
                              View
                            </AppButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="app-table-footer">
                  <div>
                    <span>Lesson Author:</span>
                    {metaContentInfo?.contentMaintainedBy.name}
                  </div>
                  <div>
                    <span>Lesson Vetting:</span>
                    {metaContentInfo?.assignedTutorForReview.name}
                  </div>
                  <div>
                    <span>Lesson Status:</span>
                    {metaContentInfo?.status ? contentStatus[metaContentInfo?.status] : 'na'}
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">No comments found</div>
            )}
          </>
        )}
      </div>

      <TablePaginate
        maxCount={total}
        currentPage={page}
        defaultLimit={params.limit}
        setPage={(page) => setParams((x) => ({ ...x, page }))}
        handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
      />
    </>
  );
}

export default memo(CommentHistory);
